import * as React from 'react';
import Types from '../../Types';

interface IComponentProps {
  id?: any;
  activePaging: any;
  activeRows: any;
  activeSorting: any;
  key: string;
  label: boolean;
  clearFilter: any;
  save: any;
  filterComponent: any;
  columns: any;
  stateValue: any;
  parentState: any;
  actionOpen: any;
  setValue: any;
  handleChange?: any;
  actionSave: any;
  reset: any;
  data?: any;
  openedMenuName: any;
  tableName: string;
}

const Item: React.FC<IComponentProps> = ({ ...props }) => {
  const {
    id,
    activePaging,
    activeRows,
    activeSorting,
    clearFilter,
    columns,
    openedMenuName,
    filterComponent,
    stateValue,
    parentState,
    actionOpen,
    setValue,
    handleChange,
    actionSave,
    reset,
    tableName,
  } = props;

  return (
    <span key={id}>
      <Types
        activePaging={activePaging}
        activeRows={activeRows}
        activeSorting={activeSorting}
        action={clearFilter}
        label={true}
        columns={columns}
        name={filterComponent.type}
        filterComponent={filterComponent}
        stateValue={stateValue}
        parentState={parentState}
        actionOpen={actionOpen}
        setValue={setValue}
        actionSave={actionSave}
        reset={reset}
        openedMenuName={openedMenuName}
        tableName={tableName}
      />
    </span>
  );
};

export default Item;
